import { useState } from "react";
import useSize from "../../../Utils/useSize/useSize";
import Header from "./Header/Header";
import Create from "./Create/Create";
import Bank from "./Bank/Bank";
import Deposit from "./Deposit/Deposit";
import Withdrawal from "./Withdrawal/Withdrawal";
import moment from "moment";

export default function Wallet() {
  const userType = Number(localStorage.getItem("user_type") || 7);

  const windowSize = useSize();
  const [type, setType] = useState(2);
  const [master_id, setMasterId] = useState(null);

  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [end, setEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  return (
    <div
      style={{
        height: windowSize[1] - 100,
      }}
    >
      <Header
        type={type}
        updateType={(a) => setType(a)}
        master={(m) => {
          setMasterId(m);
        }}
        onFilter={(date) => {
          setStart(date.start);
          setEnd(date.end);
        }}
        userType={userType}
      />

      {type === 0 ? <Create userType={userType} /> : null}
      {type === 1 ? <Bank userType={userType} master_id={master_id} /> : null}
      {type === 2 ? (
        <Deposit
          userType={userType}
          master_id={master_id}
          start={start}
          end={end}
        />
      ) : null}
      {type === 3 ? (
        <Withdrawal
          userType={userType}
          master_id={master_id}
          start={start}
          end={end}
        />
      ) : null}
    </div>
  );
}
